mutation submitSurvey($surveyCode: String!) {
  submitSurvey(hashCode: $surveyCode) {
    success
    expired
    error
  }
}
